import * as React from 'react';

import { CloseOutlined as CloseIcon, HistoryOutlined } from '@ant-design/icons';
import { Drawer, Tag } from 'antd';

import { ChangeHistoryContent } from '../ChangeHistoryContent';
import { ChangeHistoryFilter } from '../ChangeHistoryFilter';
import { initialChangeHistoryFilter } from '../constants';
import type { ChangeHistoryFilterFormValues } from '../constants';

type ProductData = {
  id: number;
  title: string;
};

type ChangeHistoryModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  productData: ProductData;
};

export const ChangeHistoryModal = ({ isOpen, handleClose, productData }: ChangeHistoryModalProps) => {
  const [filters, setFilters] = React.useState<ChangeHistoryFilterFormValues>(initialChangeHistoryFilter);

  const handleSetFilters = (newFilters: ChangeHistoryFilterFormValues) => {
    setFilters(newFilters);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={handleClose}
      footer={null}
      width='100vw'
      title={
        <div className='flex items-center gap-3'>
          <HistoryOutlined className='text-primary text-xl' />
          <div className='flex flex-col gap-0.5'>
            <span className='text-text-heading text-base leading-tight font-semibold'>Histórico de alterações</span>
            <div className='flex items-center gap-2'>
              <Tag className='m-0 text-xs'>{productData.id}</Tag>
              <span className='text-text-secondary max-w-[300px] truncate text-xs font-normal'>
                {productData.title}
              </span>
            </div>
          </div>
        </div>
      }
      closeIcon={<CloseIcon />}
    >
      <ChangeHistoryFilter setFilters={handleSetFilters} productData={productData} />
      <ChangeHistoryContent filtersForm={filters} productData={productData} />
    </Drawer>
  );
};
